// Menu order: the single-value comparisons, then the two ranges.
export const FILTER_OPERATORS = ['equals', 'notEquals', 'gt', 'gte', 'lt', 'lte', 'between', 'notBetween'] as const

export type FilterOperator = (typeof FILTER_OPERATORS)[number]

export const isRangeOperator = (operator: FilterOperator): boolean => operator === 'between' || operator === 'notBetween'

// A freshly picked field arrives with no values, and switching between a range and a single value
// keeps the first operand, so every slot list is sized to the operator's arity.
export const fitToOperator = <T>(items: T[], operator: FilterOperator, empty: T): T[] => {
  const [first = empty] = items
  return isRangeOperator(operator) ? [first, items[1] ?? empty] : [first]
}
